import { InputAdornment, TextField } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { invokeIfCallable } from '../../library/shared';
import { error } from 'ajv/dist/vocabularies/applicator/dependencies';
import { ErrorRounded } from '@mui/icons-material';

const MoneyFormatv2 = (number, currency) => {
  // let value = e.target.value
  // console.log(value)
  // value = value.replace(/,/g, "")
  // console.log(value)
  // if (!(/^\d*(?:\.\d*)?$/).test(value)) {
  //   console.log('first')
  //   return
  // }
  if (number === '-') {
    return number;
  }
  if (number === '.') {
    return '0.';
  }
  if (number === '' || !number) {
    return '';
  }
  function hasTwoDecimalPlacesAndEndsWithZero(number) {
    let numberInt = parseInt(number * 100);
    const decimalPart = (numberInt % 100).toFixed(2); // Get the two decimal places

    if (decimalPart == 0) {
      return false;
    }
    // console.log(numberInt, number);
    // console.log({
    //   numbint: numberInt?.toString().length,
    //   number: number?.toString().length,
    // });
    // console.log(numberInt?.toString().length - number?.toString().length != -1);
    // console.log(numberInt?.toString().length - number?.toString().length);

    if (numberInt?.toString().length - number?.toString().length != -1 || number[0] == '0') {
      return false;
    } else {
      return true;
    }
  }
  if (!currency) {
    currency = 'en-IN';
  }
  if (typeof number === 'string') {
    if (number[number.length - 1] === '.') return new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(number) + '.';
    else if (number[number.length - 1] === '0' && number[number.length - 2] === '.')
      return new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(number) + '.0';
  }
  // console.log(number);
  if (isNaN(number)) {
    return '';
  } else {
    if (hasTwoDecimalPlacesAndEndsWithZero(number)) {
      return new Intl.NumberFormat(currency, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(number);
    } else {
      return new Intl.NumberFormat(currency, {
        maximumFractionDigits: 2,
      }).format(number);
    }
  }
};
const MoneyFormatv4 = (number, currency) => {
  // let value = e.target.value
  // console.log(value)
  // value = value.replace(/,/g, "")
  // console.log(value)
  // if (!(/^\d*(?:\.\d*)?$/).test(value)) {
  //   console.log('first')
  //   return
  // }
  if (number === '-') {
    return number;
  }
  if (number === '.') {
    return '0.';
  }
  if (number === '' || !number) {
    return '';
  }
  function hasTwoDecimalPlacesAndEndsWithZero(number) {
    let numberInt = parseInt(number * 100);
    const decimalPart = (numberInt % 100).toFixed(2); // Get the two decimal places

    if (decimalPart == 0) {
      return false;
    }
    // console.log(numberInt, number);
    // console.log({
    //   numbint: numberInt?.toString().length,
    //   number: number?.toString().length,
    // });
    // console.log(numberInt?.toString().length - number?.toString().length != -1);
    // console.log(numberInt?.toString().length - number?.toString().length);

    if (numberInt?.toString().length - number?.toString().length != -1 || number[0] == '0') {
      return false;
    } else {
      return true;
    }
  }
  if (!currency) {
    currency = 'en-IN';
  }
  if (typeof number === 'string') {
    if (number[number.length - 1] === '.') return new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(number) + '.';
    else if (number[number.length - 1] === '0' && number[number.length - 2] === '.')
      return new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(number) + '.0';
  }
  // console.log(number);
  if (isNaN(number)) {
    return '';
  } else {
    if (hasTwoDecimalPlacesAndEndsWithZero(number)) {
      return new Intl.NumberFormat(currency, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(number);
    } else {
      return new Intl.NumberFormat(currency, {
        maximumFractionDigits: 2,
      }).format(number);
    }
  }
};
const MoneyFormatv3 = (number, currency) => {
  if (number === '' || !number) {
    return '0.00';
  }
  return new Intl.NumberFormat('en-IN', {
    // style: 'currency',
    // currency: currency,
    minimumFractionDigits: 2, // Minimum decimal places
    maximumFractionDigits: 2, // Maximum decimal places
  }).format(number);
};

const MoneyInput = ({
  name,
  placeholder,
  size,
  type,
  value,
  onChange,
  onBlur,
  state,
  disabled,
  required,
  endAdornment,
  style,
  inputRef,
  onKeyDown = () => {},
  label,
  id,
  variant,
  sx,
  currencyType = '₹',
}) => {
  const [active, setactive] = useState(false);
  const inputElement = useRef(null);
  return (
    <TextField
      error={state?.errorStatus?.[name] == true ? true : false}
      label={label}
      id={id}
      variant={variant}
      disabled={disabled}
      onFocus={() => setactive(true)}
      onKeyDown={onKeyDown}
      onBlur={() => {
        setactive(false);
        let value = new Intl.NumberFormat('en-IN', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(state?.[name] == '.' ? 0 : state?.[name]);

        // if(isNaN(value)){
        //   onChange("")
        // }
        //  else if(value==="-"){
        //   onChange("")
        // }
        // else
        if (value == '0.00') {
          onChange('');
        } else {
          onChange(value);
        }
      }}
      value={active ? MoneyFormatv2(state?.[name]) : MoneyFormatv3(state?.[name])}
      onChange={(e) => {
        let value = e.target.value;
        value = value.replace(/,/g, '');
        const cursorPosition = e.target.selectionStart;
        // if (!/^\d*(?:\.\d*)?$/.test(value)) {
        //   return;
        // }
        if (!/^-?\d*(?:\.\d*)?$/.test(value)) {
          return;
        }
        if (/^-?\d*\.?\d{0,2}$/.test(value) == false) {
          return;
        }

        // let amount = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2, }).format(value);
        onChange(value);
        // setTimeout(() => {
        //     if (inputElement.current)
        //         inputElement?.current?.setSelectionRange(cursorPosition, cursorPosition);
        // }, 0);
      }}
      fullWidth
      size="small"
      sx={{
        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
          fontSize: '14px',
        },
        label: {
          fontSize: '14px',
        },
        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
          color: 'input.font',
        },
        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
          borderColor: 'input.border',
        },
        '.css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input': {
          textAlign: 'right',
        },
        ...sx,
      }}
      InputProps={{
        inputRef: inputElement,
        startAdornment: <InputAdornment position="start">{currencyType}</InputAdornment>,
        inputProps: {
          style: {
            textAlign: 'right',
          },
          min: 0,
        },
      }}
    />
  );
};
export const MoneyInput2 = ({
  name,
  placeholder,
  size,
  type,
  value,
  onChange,
  onBlur,
  state,
  disabled,
  required,
  endAdornment,
  style,
  inputRef,
  onKeyDown,
  label,
  id,
  variant,
  sx,
  onFocus,
}) => {
  const [active, setactive] = useState(false);
  const inputElement = useRef({});

  return (
    <TextField
      key={id}
      id={id}
      variant={variant}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
      onFocus={(e) => {
        setactive(true);
        onFocus && onFocus(e);
        e.stopPropagation();
      }}
      ref={inputRef}
      onKeyDown={onKeyDown}
      onBlur={() => {
        setactive(false);
        let value = new Intl.NumberFormat('en-IN', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(state);
        if (value === '0.00') {
          onChange('');
        } else {
          onChange(value);
          onBlur(value);
        }
      }}
      value={active ? MoneyFormatv2(state) : MoneyFormatv3(state)}
      onChange={(e) => {
        let value = e.target.value;
        value = value.replace(/,/g, '');
        const cursorPosition = e.target.selectionStart;
        if (!/^\d*(?:\.\d*)?$/.test(value)) {
          return;
        }
        if (/^\d*\.?\d{0,2}$/.test(value) === false) {
          return;
        }
        onChange(value);
      }}
      fullWidth
      size="small"
      sx={{
        textAlign: 'right',
        '.MuiInputBase-root': {
          fontSize: '14px',
        },
        label: {
          fontSize: '14px',
        },
        '.MuiFormLabel-root': {
          color: 'input.font',
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'input.border',
        },
        '.MuiOutlinedInput-input': {
          textAlign: 'right',
        },
        ...sx,
      }}
      InputProps={{
        inputRef: inputElement,
        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
        inputProps: {
          style: {
            textAlign: 'right',
          },
          min: 0,
        },
      }}
    />
  );
};

export const MoneyInputv3 = React.memo(
  ({
    name,
    placeholder,
    size,
    type,
    value,
    onChange,
    onBlur,
    onFocus,
    onClick,
    state,
    disabled,
    required,
    endAdornment,
    style,
    inputRef,
    onKeyDown,
    label,
    id,
    variant,
    sx,
    inputProps,
    currencyType = '₹',
    error,
  }) => {
    const [active, setactive] = useState(false);
    const inputElement = useRef({});

    const handleClick = useCallback(
      (e) => {
        onClick?.(e);
        e.stopPropagation();
      },
      [onClick]
    );

    const handleFocus = useCallback(
      (e) => {
        setactive(true);
        onFocus?.(e);
        e.stopPropagation();
      },
      [onFocus]
    );

    const handleBlur = useCallback(() => {
      setactive(false);
      const value = new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(state);
      onBlur?.(value);
    }, [state, onBlur]);

    const handleChange = useCallback(
      (e) => {
        let value = e.target.value.replace(/,/g, '');
        onChange(value);
      },
      [onChange]
    );

    const textFieldProps = useMemo(
      () => ({
        error: error || '',
        key: id,
        id,
        variant,
        disabled,
        label,
        inputRef,
        onKeyDown,
        fullWidth: true,
        size: 'small',
        value: active ? MoneyFormatv2(state) : MoneyFormatv3(state),
        slotProps: {
          input: {
            readOnly: true,
          },
        },
        sx: {
          textAlign: 'right',
          '.MuiInputBase-root': {
            fontSize: '14px',
            '&.Mui-disabled': {
              color: 'black',
              WebkitTextFillColor: 'black',
            },
          },
          label: {
            fontSize: '14px',
          },
          '.MuiFormLabel-root': {
            color: 'input.font',
            '&.Mui-disabled': {
              color: 'black',
            },
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'input.border',
            '&.Mui-disabled': {
              borderColor: 'black',
            },
          },
          '.MuiOutlinedInput-input': {
            textAlign: 'right',
            '&.Mui-disabled': {
              color: 'black',
              WebkitTextFillColor: 'black',
            },
          },
          ...sx,
        },
        InputProps: {
          inputRef: inputElement,
          startAdornment: <InputAdornment position="start">{currencyType}</InputAdornment>,
          inputProps: {
            style: {
              textAlign: 'right',
            },
            min: 0,
            readOnly: inputProps?.readOnly,
          },
        },
      }),
      [active, state, error, id, variant, disabled, label, inputRef, onKeyDown, sx, currencyType, inputProps]
    );

    return <TextField {...textFieldProps} onClick={handleClick} onFocus={handleFocus} onBlur={handleBlur} onChange={handleChange} />;
  }
);
export default MoneyInput;
